export function formatUserShortName(
  name: string | null | undefined
): string | null {
  if (!name) {
    return null;
  }

  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return null;
  }

  const firstName = parts[0];

  if (parts.length === 1) {
    return firstName;
  }

  const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();

  return `${firstName} ${lastInitial}`;
}
